export const breakpoints = ["base", "sm", "md", "lg", "xl", "2xl"] as const;
export type Breakpoint = (typeof breakpoints)[number];
export const isBreakpoint = (item: string): item is Breakpoint => (breakpoints as readonly string[]).includes(item);
